module.exports = __webpack_public_path__ + "img/domain.b43b71b0.svg";